import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _dec, _dec2, _dec3, _class, _class2, _descriptor;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { inject, injectable, postConstruct } from 'inversify';
import 'reflect-metadata';
import { TYPES } from '../../../types';
import { gl } from '../gl';
var PostProcessor = (_dec = injectable(), _dec2 = inject(TYPES.IRendererService), _dec3 = postConstruct(), _dec(_class = (_class2 = function () {
  function PostProcessor() {
    _classCallCheck(this, PostProcessor);

    _initializerDefineProperty(this, "rendererService", _descriptor, this);

    _defineProperty(this, "passes", []);

    _defineProperty(this, "readFBO", void 0);

    _defineProperty(this, "writeFBO", void 0);
  }

  _createClass(PostProcessor, [{
    key: "getReadFBO",
    value: function getReadFBO() {
      return this.readFBO;
    }
  }, {
    key: "getWriteFBO",
    value: function getWriteFBO() {
      return this.writeFBO;
    }
  }, {
    key: "getCurrentFBOTex",
    value: function getCurrentFBOTex() {
      var _this$rendererService = this.rendererService,
          getViewportSize = _this$rendererService.getViewportSize,
          createTexture2D = _this$rendererService.createTexture2D;

      var _getViewportSize = getViewportSize(),
          width = _getViewportSize.width,
          height = _getViewportSize.height;

      return createTexture2D({
        x: 0,
        y: 0,
        width: width,
        height: height,
        copy: true
      });
    }
  }, {
    key: "getReadFBOTex",
    value: function getReadFBOTex() {
      var _this = this;

      var useFramebuffer = this.rendererService.useFramebuffer;
      return new Promise(function (resolve, reject) {
        useFramebuffer(_this.readFBO, _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  resolve(_this.getCurrentFBOTex());

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      });
    }
  }, {
    key: "renderBloomPass",
    value: function () {
      var _renderBloomPass = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(layer, pass) {
        var tex, count;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getReadFBOTex();

              case 2:
                tex = _context2.sent;
                count = 0;

              case 4:
                if (!(count < 4)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 7;
                return pass.render(layer, tex);

              case 7:
                this.swap();
                count++;
                _context2.next = 4;
                break;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function renderBloomPass(_x, _x2) {
        return _renderBloomPass.apply(this, arguments);
      }

      return renderBloomPass;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(layer) {
        var i, pass;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < this.passes.length)) {
                  _context3.next = 15;
                  break;
                }

                pass = this.passes[i];
                pass.setRenderToScreen(this.isLastEnabledPass(i));

                if (!(pass.getName() === 'bloom')) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 7;
                return this.renderBloomPass(layer, pass);

              case 7:
                _context3.next = 12;
                break;

              case 9:
                _context3.next = 11;
                return pass.render(layer);

              case 11:
                if (i !== this.passes.length - 1) {
                  this.swap();
                }

              case 12:
                i++;
                _context3.next = 1;
                break;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function render(_x3) {
        return _render.apply(this, arguments);
      }

      return render;
    }()
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.readFBO.resize({
        width: width,
        height: height
      });
      this.writeFBO.resize({
        width: width,
        height: height
      });
    }
  }, {
    key: "add",
    value: function add(pass, layer, config) {
      pass.init(layer, config);
      this.passes.push(pass);
    }
  }, {
    key: "insert",
    value: function insert(pass, index, layer, config) {
      pass.init(layer, config);
      this.passes.splice(index, 0, pass);
    }
  }, {
    key: "getPostProcessingPassByName",
    value: function getPostProcessingPassByName(name) {
      return this.passes.find(function (p) {
        return p.getName() === name;
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this$rendererService2 = this.rendererService,
          createFramebuffer = _this$rendererService2.createFramebuffer,
          createTexture2D = _this$rendererService2.createTexture2D;
      this.readFBO = createFramebuffer({
        color: createTexture2D({
          width: 1,
          height: 1,
          wrapS: gl.CLAMP_TO_EDGE,
          wrapT: gl.CLAMP_TO_EDGE
        })
      });
      this.writeFBO = createFramebuffer({
        color: createTexture2D({
          width: 1,
          height: 1,
          wrapS: gl.CLAMP_TO_EDGE,
          wrapT: gl.CLAMP_TO_EDGE
        })
      });
    }
  }, {
    key: "isLastEnabledPass",
    value: function isLastEnabledPass(index) {
      for (var i = index + 1; i < this.passes.length; i++) {
        if (this.passes[i].isEnabled()) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "swap",
    value: function swap() {
      var tmp = this.readFBO;
      this.readFBO = this.writeFBO;
      this.writeFBO = tmp;
    }
  }]);

  return PostProcessor;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "rendererService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "init", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "init"), _class2.prototype)), _class2)) || _class);
export { PostProcessor as default };
//# sourceMappingURL=PostProcessor.js.map